import { Injectable } from '@angular/core';
import { Platform } from 'ionic-angular';
import { AppSettings } from '../../app/app.settings';

const win: any = window;

@Injectable()
export class FacebookServiceProvider {
  constructor(private platform: Platform) {}

  init() {
    this.platform.ready().then(() => {
      if (win.FB) {
        win.FB.init({
          appId: AppSettings.getFBAppID(),
          status: true,
          cookie: true,
          xfbml: true,
          version: 'v2.4'
        });
      }
    });
  }

  share(link, message) {
    if (win.FB) {
      win.FB.ui(
        {
          method: 'share',
          name: 'Lubbu',
          link: link,
          href: link,
          picture: 'http://fbrell.com/f8.jpg',
          caption: message,
          description:
            'Sign Up for Lubbu now! If you don\'t ask, the answer\'s always, "no."',
          action_properties: JSON.stringify({
            object: link
          })
        },
        function() {}
      );
    }
  }
}



// WEBPACK FOOTER //
// ./src/providers/facebook-service/facebook-service.ts